export const InvoicePaymentValidation = (formData) => {
    const errors = {};
   
    if (!formData.mon_Amount || formData.mon_Amount==="") {
        errors.mon_Amount = 'This field is required';
    }
    if (!formData.dt_PaymentDate || formData.dt_PaymentDate==="") {
        errors.dt_PaymentDate = 'This field is required';
    }
    if (!formData.snt_PaymentType || formData.snt_PaymentType==="") {
        errors.snt_PaymentType = 'This field is required';
    }
    
    return errors;
};
